import React from "react";
import Evaluations from "./Evaluations";

function CommonEval() {

    return (
        <div className=" flex w-full">
          <Evaluations commune={true} />
        </div>
    );
}

export default CommonEval;